// removed by extract-text-webpack-plugin
module.exports = {"Pepper30":"#D8D8D6","Black":"#333D47","dropdownContainer":"G77c034","arrowDown":"G77d206 Gb69063 Gfc1db7"};